/**
 * Options passed from the CSV modal to the Phone server export callback.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { ServerCsvExportOptions } from './hooks/useCsvExportModalState.types';
import { sanitizeCsvDownloadBaseName } from './sanitizeCsvDownloadBaseName';

export function buildServerCsvExportOptions(p: {
  excludeCrossSourceNotedRows: boolean;
  exportDownloadBaseName: string;
}): ServerCsvExportOptions {
  const base = sanitizeCsvDownloadBaseName(
    p.exportDownloadBaseName.trim() || undefined,
  );
  const out: ServerCsvExportOptions = {};
  if (p.excludeCrossSourceNotedRows) out.excludeCrossSourceNotedRows = true;
  if (base) out.downloadBaseName = base;
  return out;
}
